import React from 'react';
import { Download, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { useNavigate } from 'react-router-dom';

const DownloadPage = () => {
  const navigate = useNavigate();

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/wakacyjna-przystan-website.zip';
    link.download = 'wakacyjna-przystan-website.zip';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full shadow-2xl">
        <CardContent className="p-8">
          <div className="text-center mb-8">
            <div className="w-20 h-20 bg-cyan-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Download className="w-10 h-10 text-cyan-600" />
            </div>
            <h1 className="text-3xl font-bold text-slate-800 mb-3">
              Pobierz pliki strony
            </h1>
            <p className="text-slate-600 text-lg">
              Wakacyjna Przystań - Website Files
            </p>
          </div>

          <div className="bg-slate-50 rounded-lg p-6 mb-6">
            <h2 className="text-xl font-semibold text-slate-800 mb-4">Zawartość archiwum ZIP:</h2>
            <ul className="space-y-2 text-slate-600">
              <li className="flex items-start">
                <span className="text-cyan-600 mr-2">•</span>
                Wszystkie komponenty React (src/)
              </li>
              <li className="flex items-start">
                <span className="text-cyan-600 mr-2">•</span>
                Główny komponent: TravelAgencyLanding.jsx
              </li>
              <li className="flex items-start">
                <span className="text-cyan-600 mr-2">•</span>
                Komponenty Shadcn UI
              </li>
              <li className="flex items-start">
                <span className="text-cyan-600 mr-2">•</span>
                Konfiguracja Tailwind CSS
              </li>
              <li className="flex items-start">
                <span className="text-cyan-600 mr-2">•</span>
                package.json i .env
              </li>
              <li className="flex items-start">
                <span className="text-cyan-600 mr-2">•</span>
                Pliki public/
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={handleDownload}
              className="flex-1 bg-cyan-600 hover:bg-cyan-700 text-white py-6 text-lg"
              size="lg"
            >
              <Download className="mr-2 h-5 w-5" />
              Pobierz ZIP (55 KB)
            </Button>
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="sm:w-auto"
              size="lg"
            >
              <ArrowLeft className="mr-2 h-5 w-5" />
              Powrót do strony
            </Button>
          </div>

          <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <p className="text-sm text-blue-800">
              <strong>Uwaga:</strong> Po pobraniu, rozpakuj archiwum i uruchom{' '}
              <code className="bg-blue-100 px-2 py-1 rounded">yarn install</code> aby zainstalować zależności, 
              a następnie <code className="bg-blue-100 px-2 py-1 rounded">yarn start</code> aby uruchomić projekt lokalnie.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DownloadPage;
